module.exports = __webpack_public_path__ + "img/bg1.4de0eee5.png";